export const createOptions = (ids = [], labelsById = {}) =>
    ids.map(id => ({
        label: labelsById[id] || id,
        value: id,
    }));
export const passParam = (state, params) => params;
